import React from 'react';
import type { LeaderboardProps } from '../../types';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';

const Leaderboard: React.FC<LeaderboardProps> = ({
  participants,
  limit = 10
}) => {
  // Sort participants by score (descending)
  const sortedParticipants = [...participants]
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);

  const getOrdinal = (position: number): string => {
    if (position === 1) return "🥇";
    if (position === 2) return "🥈";
    if (position === 3) return "🥉";
    return `${position}th`;
  };

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Leaderboard</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {sortedParticipants.map((participant, index) => (
            <div 
              key={participant._id || index}
              className={`flex justify-between items-center p-3 rounded-lg ${
                index < 3 ? 'bg-primary/10' : 'bg-muted'
              }`}
            >
              <div className="flex items-center gap-2">
                <span className="font-bold w-8">{getOrdinal(index + 1)}</span>
                <span className="font-medium">{participant.nickname}</span>
              </div>
              <span className="font-bold">{participant.score}</span>
            </div>
          ))}

          {sortedParticipants.length === 0 && (
            <div className="text-center py-4 text-muted-foreground">
              No participants yet
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default Leaderboard;